import React from 'react';
import './TopBanner.css';

const TopBanner = () => (
  <div className="top-banner">
  <marquee>
   Smooth Sesame Goodness💛
    </marquee>
  </div>
);

export default TopBanner;
